import React from 'react';
export interface SelectOption {
  value: string;
  label: string;
}
export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options: SelectOption[];
  required?: boolean;
}
export function Select({
  label,
  error,
  helperText,
  options,
  required,
  className = '',
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-248">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-249">
          {label}
          {required && <span className="text-red-500 ml-1" data-id="element-250">*</span>}
        </label>}
      <select className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${error ? 'border-red-500' : 'border-gray-300'} ${className}`} {...props} data-id="element-251">
        <option value="" data-id="element-252">Select...</option>
        {options.map(option => <option key={option.value} value={option.value} data-id="element-253">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-254">{error}</p>}
      {helperText && !error && <p className="mt-1 text-sm text-gray-500" data-id="element-255">{helperText}</p>}
    </div>;
}